<template>
  <div v-if="sink >= 0">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppFloating',
  props: ['principal-ref'],
  data() {
    return {
      sink: -1,
      timeoutId: null,
    };
  },
  mounted() {
    this.timeoutId = setInterval(this.calculateSink, 500);
  },
  methods: {
    calculateSink() {
      const rect = this.principalRef.getBoundingClientRect();
      const sink = Math.max(rect.top - window.innerHeight, -rect.bottom);
      if (sink !== this.sink) {
        this.sink = sink;
        this.$emit('update', this.sink);
      }
    },
  },
  beforeUnmount() {
    clearInterval(this.timeoutId);
  },
};
</script>
